'use client';

import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';


const filterTabs = [
  { id: 'filter-all', label: 'All Discussions', count: 4820 },
  { id: 'filter-debates', label: 'Movie Debates', count: 1240 },
  { id: 'filter-recs', label: 'Recommendations', count: 980 },
  { id: 'filter-reviews', label: 'Review Talk', count: 760 },
  { id: 'filter-spoilers', label: 'Spoiler Zone', count: 540 },
];

const threads = [
  { id: 'thread-001', title: 'Is Oppenheimer truly the best film of the decade, or is the hype overblown?', category: 'debates', author: 'Sofia Reyes', authorInitials: 'SR', movieTag: 'Oppenheimer', tags: ['Christopher Nolan', 'Oscar Season', 'Drama'], replies: 284, views: 12480, votes: 847, lastActivity: '12 min ago', pinned: true, spoiler: false, excerpt: "I've seen it twice now and while I think it's exceptional, I'm wondering if the discourse around it has elevated it beyond its actual quality. What do you all think?" },
  { id: 'thread-002', title: 'Dune: Part Two — does Zendaya\'s expanded role live up to expectations?', category: 'debates', author: 'James Okafor', authorInitials: 'JO', movieTag: 'Dune: Part Two', tags: ['Denis Villeneuve', 'Sci-Fi', 'Casting'], replies: 192, views: 8730, votes: 623, lastActivity: '34 min ago', pinned: false, spoiler: false, excerpt: "After the first film, expectations were sky-high for Chani's arc. Did the film deliver or was she underutilized again?" },
  { id: 'thread-003', title: 'Best films for someone new to art house cinema — where to start?', category: 'recs', author: 'Priya Nair', authorInitials: 'PN', movieTag: null, tags: ['Art House', 'Beginner', 'Recommendations'], replies: 156, views: 6920, votes: 512, lastActivity: '1 hour ago', pinned: false, spoiler: false, excerpt: "My partner has never watched anything outside of mainstream Hollywood. I want to introduce them to world cinema gently. Any suggestions?" },
  { id: 'thread-004', title: 'The ending of Poor Things explained — what does it all mean?', category: 'spoilers', author: 'Tomas Novak', authorInitials: 'TN', movieTag: 'Poor Things', tags: ['Yorgos Lanthimos', 'Ending', 'Analysis'], replies: 134, views: 5640, votes: 389, lastActivity: '2 hours ago', pinned: false, spoiler: true, excerpt: "The final scene left me speechless. I have some theories about what Bella\'s choice represents in the context of the whole film." },
  { id: 'thread-005', title: 'Past Lives vs. Aftersun — which is the more emotionally devastating film?', category: 'debates', author: 'Amara Diallo', authorInitials: 'AD', movieTag: null, tags: ['A24', 'Drama', 'Emotional'], replies: 118, views: 4980, votes: 445, lastActivity: '3 hours ago', pinned: false, spoiler: false, excerpt: "Both films wrecked me in different ways. Past Lives hits you with its restraint, Aftersun with its ambiguity. How do you choose?" },
  { id: 'thread-006', title: 'Saltburn — misunderstood masterpiece or style over substance?', category: 'debates', author: 'Kenji Watanabe', authorInitials: 'KW', movieTag: 'Saltburn', tags: ['Emerald Fennell', 'Thriller', 'Controversial'], replies: 312, views: 15670, votes: 234, lastActivity: '4 hours ago', pinned: false, spoiler: false, excerpt: "The discourse around this film has been wild. Either people love it or they're furious about the ending. Where do you stand?" },
  { id: 'thread-007', title: 'Hidden gems of 2023 that deserve more attention', category: 'recs', author: 'Elena Vasquez', authorInitials: 'EV', movieTag: null, tags: ['Hidden Gems', '2023', 'Underrated'], replies: 89, views: 3450, votes: 678, lastActivity: '5 hours ago', pinned: false, spoiler: false, excerpt: "Everyone\'s talking about the big awards films but what about the smaller movies that slipped under the radar? Let\'s compile a list." },
  { id: 'thread-008', title: 'Christopher Nolan\'s filmography ranked — the definitive community list', category: 'debates', author: 'Marcus Kim', authorInitials: 'MK', movieTag: null, tags: ['Christopher Nolan', 'Rankings', 'Director'], replies: 445, views: 22340, votes: 1240, lastActivity: '6 hours ago', pinned: false, spoiler: false, excerpt: "After Oppenheimer, it's time to revisit his entire filmography. Cast your votes and let's settle this once and for all." },
  { id: 'thread-009', title: 'Are AI-generated film scores ruining the art of movie music?', category: 'debates', author: 'Priya Nair', authorInitials: 'PN', movieTag: null, tags: ['Music', 'AI', 'Controversy'], replies: 76, views: 2890, votes: 312, lastActivity: '8 hours ago', pinned: false, spoiler: false, excerpt: "A major studio just announced their next blockbuster will use an AI-composed score. I have thoughts, and they're not good." },
  { id: 'thread-010', title: 'Society of the Snow — how does it compare to Alive (1993)?', category: 'debates', author: 'James Okafor', authorInitials: 'JO', movieTag: 'Society of the Snow', tags: ['Survival', 'Comparison', 'Spanish Cinema'], replies: 67, views: 2340, votes: 289, lastActivity: '10 hours ago', pinned: false, spoiler: false, excerpt: "Both films tackle the same real-life event but with completely different approaches. Which version resonates more deeply?" },
  { id: 'thread-011', title: 'Monthly rewatch club — July 2026: The Godfather trilogy', category: 'recs', author: 'Sofia Reyes', authorInitials: 'SR', movieTag: 'The Godfather', tags: ['Rewatch Club', 'Classics', 'Coppola'], replies: 54, views: 1870, votes: 423, lastActivity: '12 hours ago', pinned: false, spoiler: false, excerpt: "This month we\'re revisiting Coppola\'s masterwork. Join us for daily discussion threads as we work through all three films." },
  { id: 'thread-012', title: 'Recommend a film for each mood — the ultimate guide', category: 'recs', author: 'Amara Diallo', authorInitials: 'AD', movieTag: null, tags: ['Mood', 'Guide', 'Recommendations'], replies: 203, views: 8920, votes: 892, lastActivity: '1 day ago', pinned: false, spoiler: false, excerpt: "Feeling sad? Anxious? Euphoric? Bored? Let\'s build the definitive mood-to-film recommendation matrix together." },
];

export default function ThreadList() {
  const [activeFilter, setActiveFilter] = useState('filter-all');
  const [sortBy, setSortBy] = useState<'activity' | 'votes' | 'replies'>('activity');
  const [showNewThreadModal, setShowNewThreadModal] = useState(false);
  const [newThreadTitle, setNewThreadTitle] = useState('');
  const [newThreadBody, setNewThreadBody] = useState('');
  const [newThreadSpoiler, setNewThreadSpoiler] = useState(false);

  const filtered = threads.filter((t) => {
    if (activeFilter === 'filter-all') return true;
    if (activeFilter === 'filter-debates') return t.category === 'debates';
    if (activeFilter === 'filter-recs') return t.category === 'recs';
    if (activeFilter === 'filter-spoilers') return t.spoiler;
    if (activeFilter === 'filter-reviews') return t.category === 'reviews';
    return true;
  });

  const sorted = [...filtered].sort((a, b) => {
    if (sortBy === 'votes') return b.votes - a.votes;
    if (sortBy === 'replies') return b.replies - a.replies;
    return 0;
  });

  return (
    <div>
      {/* Filter tabs */}
      <div className="flex items-center gap-1 overflow-x-auto scrollbar-hide border-b border-border mb-5 pb-0">
        {filterTabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveFilter(tab.id)}
            className={`flex items-center gap-1.5 px-4 py-3 text-sm font-600 border-b-2 whitespace-nowrap transition-colors duration-150 -mb-px flex-shrink-0 ${
              activeFilter === tab.id
                ? 'border-primary text-foreground'
                : 'border-transparent text-muted-foreground hover:text-foreground'
            }`}
          >
            {tab.label}
            <span className="text-xs text-muted-foreground">({tab.count.toLocaleString()})</span>
          </button>
        ))}
      </div>

      {/* Controls */}
      <div className="flex items-center justify-between mb-4 flex-wrap gap-3">
        <div className="flex items-center gap-2">
          <span className="text-sm text-muted-foreground">{sorted.length} threads</span>
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value as typeof sortBy)}
            className="input-dark text-xs px-2.5 py-1.5"
          >
            <option value="activity">Recent Activity</option>
            <option value="votes">Most Voted</option>
            <option value="replies">Most Replies</option>
          </select>
        </div>
        <button
          onClick={() => setShowNewThreadModal(true)}
          className="btn-primary flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-700"
        >
          <Icon name="PlusIcon" size={14} />
          Start Discussion
        </button>
      </div>

      {/* Thread list */}
      <div className="space-y-2">
        {sorted.map((thread) => (
          <div key={thread.id} className={`p-4 rounded-2xl bg-card border transition-all duration-150 thread-row cursor-pointer ${thread.pinned ? 'border-primary/30 bg-primary/5' : 'border-border hover:border-border/80'}`}>
            <div className="flex items-start gap-3">
              {/* Vote column */}
              <div className="flex flex-col items-center gap-1 flex-shrink-0 pt-1">
                <button className="text-muted-foreground hover:text-accent transition-colors" aria-label="Upvote">
                  <Icon name="ChevronUpIcon" size={16} />
                </button>
                <span className="text-xs font-700 text-foreground font-mono-nums">{thread.votes}</span>
                <button className="text-muted-foreground hover:text-primary transition-colors" aria-label="Downvote">
                  <Icon name="ChevronDownIcon" size={16} />
                </button>
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap mb-1.5">
                  {thread.pinned && (
                    <span className="flex items-center gap-1 text-xs text-gold font-600">
                      <Icon name="StarIcon" variant="solid" size={10} className="text-gold" />
                      Pinned
                    </span>
                  )}
                  {thread.spoiler && (
                    <span className="px-1.5 py-0.5 rounded text-xs font-600 status-flagged">Spoilers</span>
                  )}
                  {thread.movieTag && (
                    <span className="tag-pill">{thread.movieTag}</span>
                  )}
                  <span className={`px-2 py-0.5 rounded-full text-xs font-500 ${
                    thread.category === 'debates' ? 'bg-primary/10 text-primary border border-primary/20' :
                    thread.category === 'recs'? 'bg-green-500/10 text-green-400 border border-green-500/20' : 'bg-purple-500/10 text-purple-400 border border-purple-500/20'
                  }`}>
                    {thread.category === 'debates' ? 'Debate' : thread.category === 'recs' ? 'Recommendation' : 'Spoilers'}
                  </span>
                </div>

                <h3 className="text-sm font-700 text-foreground hover:text-accent transition-colors leading-snug mb-2 line-clamp-2">
                  {thread.title}
                </h3>

                <p className="text-xs text-muted-foreground leading-relaxed line-clamp-2 mb-3">{thread.excerpt}</p>

                {/* Tags */}
                <div className="flex flex-wrap gap-1.5 mb-3">
                  {thread.tags.map((tag) => (
                    <span key={`thread-tag-${thread.id}-${tag}`} className="text-xs text-muted-foreground/70 bg-muted/50 px-2 py-0.5 rounded-full">
                      #{tag.replace(' ', '')}
                    </span>
                  ))}
                </div>

                {/* Meta */}
                <div className="flex items-center gap-4 text-xs text-muted-foreground flex-wrap">
                  <div className="flex items-center gap-1.5">
                    <div className="w-5 h-5 rounded-full bg-gradient-to-br from-primary/50 to-purple-800/50 flex items-center justify-center text-xs font-700 text-white">
                      {thread.authorInitials}
                    </div>
                    <span>{thread.author}</span>
                  </div>
                  <span className="flex items-center gap-1">
                    <Icon name="ChatBubbleOvalLeftIcon" size={12} />
                    {thread.replies} replies
                  </span>
                  <span className="flex items-center gap-1">
                    <Icon name="EyeIcon" size={12} />
                    {thread.views.toLocaleString()} views
                  </span>
                  <span className="flex items-center gap-1">
                    <Icon name="ClockIcon" size={12} />
                    {thread.lastActivity}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Load more */}
      <div className="mt-6 text-center">
        <button className="btn-ghost px-8 py-3 rounded-xl text-sm font-600">
          Load More Discussions
        </button>
      </div>

      {/* New thread modal */}
      {showNewThreadModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center modal-backdrop" onClick={() => setShowNewThreadModal(false)}>
          <div className="glass-card-elevated rounded-2xl p-6 max-w-xl w-full mx-4 shadow-modal scale-in" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-5">
              <h3 className="text-lg font-700 text-foreground">Start a Discussion</h3>
              <button onClick={() => setShowNewThreadModal(false)} className="btn-ghost p-2 rounded-lg">
                <Icon name="XMarkIcon" size={16} />
              </button>
            </div>

            <div className="space-y-4">
              <div>
                <label className="block text-sm font-500 text-foreground mb-1.5">Discussion Title</label>
                <p className="text-xs text-muted-foreground mb-2">Make it specific and interesting — good titles get more engagement</p>
                <input
                  type="text"
                  value={newThreadTitle}
                  onChange={(e) => setNewThreadTitle(e.target.value)}
                  placeholder="e.g. Is Oppenheimer truly the best film of the decade?"
                  className="input-dark w-full px-4 py-3 text-sm"
                />
              </div>

              <div>
                <label className="block text-sm font-500 text-foreground mb-1.5">Movie / Topic Tag (optional)</label>
                <input
                  type="text"
                  placeholder="e.g. Oppenheimer, Christopher Nolan..."
                  className="input-dark w-full px-4 py-3 text-sm"
                />
              </div>

              <div>
                <label className="block text-sm font-500 text-foreground mb-1.5">Your Opening Post</label>
                <textarea
                  value={newThreadBody}
                  onChange={(e) => setNewThreadBody(e.target.value)}
                  rows={5}
                  placeholder="Share your thoughts, questions, or perspective to kick off the discussion..."
                  className="input-dark w-full px-4 py-3 text-sm resize-none"
                />
              </div>

              <div>
                <label className="block text-sm font-500 text-foreground mb-2">Category</label>
                <div className="grid grid-cols-3 gap-2">
                  {[
                    { value: 'debates', label: 'Debate', color: 'border-primary text-primary bg-primary/10' },
                    { value: 'recs', label: 'Recommendation', color: 'border-green-500 text-green-400 bg-green-500/10' },
                    { value: 'general', label: 'General', color: 'border-border text-muted-foreground bg-muted/30' },
                  ].map((cat) => (
                    <button key={`newthread-cat-${cat.value}`} type="button" className={`py-2 rounded-lg text-xs font-600 border transition-colors ${cat.color}`}>
                      {cat.label}
                    </button>
                  ))}
                </div>
              </div>

              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={newThreadSpoiler}
                  onChange={(e) => setNewThreadSpoiler(e.target.checked)}
                  className="rounded"
                />
                <span className="text-sm text-muted-foreground">This post contains spoilers</span>
              </label>

              <div className="flex items-center gap-3 pt-2">
                <button
                  disabled={!newThreadTitle.trim() || !newThreadBody.trim()}
                  className="btn-primary flex-1 py-3 rounded-xl text-sm font-700 disabled:opacity-50"
                  onClick={() => setShowNewThreadModal(false)}
                >
                  Post Discussion
                </button>
                <button onClick={() => setShowNewThreadModal(false)} className="btn-ghost px-6 py-3 rounded-xl text-sm">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}